import styled from 'styled-components';
export const StyledTablePageTitleContainer = styled.div `
  display: flex;
  flex-direction: column;

  .page-title-container {
    padding-bottom: 0;
  }
`;
